import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";
import React, { useMemo } from "react";
import { Input } from "semantic-ui-react";
import { addDays } from "../../utils";
import moment from "moment-timezone";

interface DateRangePickerProps {
  startDate?: Date | undefined;
  endDate?: Date | undefined;
  minDate?: Date | undefined;
  maxDate?: Date | undefined;
  onChangeStartDate?: (startDate: Date | undefined) => void;
  onChangeEndDate?: (endDate: Date | undefined) => void;
  editable?: boolean;
}

type Props = DateRangePickerProps;

export const DateRangePicker: React.FC<Props> = ({
  startDate,
  endDate,
  editable = true,
  minDate,
  maxDate,
  onChangeEndDate,
  onChangeStartDate,
}) => {
  const startMax = useMemo(() => {
    return endDate ? addDays(endDate, -1) : maxDate ? addDays(maxDate, -1) : undefined;
  }, [endDate, maxDate]);

  const endMin = useMemo(() => {
    return startDate ? addDays(startDate, 1) : minDate ? addDays(minDate, 1) : undefined;
  }, [startDate, minDate]);

  return (
    <div className={"scDatePicker"}>
      <DatePicker
        customInput={<Input icon="calendar alternate outline" className={"datePickerInput"} />}
        data-elm-id={"startDateSelector"}
        id={"start-date-selector"}
        name={"start-date-selector"}
        selected={startDate}
        onChange={(date: any) => {
          if (date && onChangeStartDate) {
            const startOfDay = moment(date).tz(moment.tz.guess()).startOf("day").toDate();
            onChangeStartDate(startOfDay);
          }
        }}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={15}
        maxDate={startMax}
        minDate={minDate}
        dateFormat="EE, MM/dd/yyyy"
        disabled={!editable}
        autoComplete={"off"}
        placeholderText={"Start date"}
      />

      <DatePicker
        customInput={<Input icon="calendar alternate outline" className={"datePickerInput"} />}
        data-elm-id={"endDateSelector"}
        id={"end-date-selector"}
        name={"end-date-selector"}
        selected={endDate}
        onChange={(date: Date | null) => {
          if (date && onChangeEndDate) {
            const endOfDay = moment(date).tz(moment.tz.guess()).endOf("day").toDate();
            onChangeEndDate(endOfDay);
          }
        }}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={15}
        minDate={endMin}
        maxDate={maxDate}
        dateFormat="EE, MM/dd/yyyy"
        disabled={!editable}
        autoComplete={"off"}
        placeholderText={"End date"}
      />
    </div>
  );
};
